var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"dn-margin-1"},[_c('div',{attrs:{"id":"homePage"}},_vm._l((_vm.products),function(product){return _c('ProductCard',{key:product.id,attrs:{"title":product.title,"image":product.image},on:{"click":function($event){return _vm.openPage(product.id)}}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e16698d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dualLens.vue
// module id = null
// module chunks = 